import { translate } from "@classdojo/web/utils/translate";
import icon from "./assets/logo.svg";
import createToolPod from "src/infra/createToolPod";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";
import { ToolListItem } from "src/pods/toolkitData/components/EditableSetup";

export const appMetadataList = (): AppMetadata => ({
  href: "list",
  title: translate("dojo.toolkit:apps.directions"),
  backgroundColor: "dt_content_success",
  icon,
});

const STATE_KEY = "list";

type ListState = {
  list: ToolListItem[];
  title: string;
};

export type ListSlice = {
  [STATE_KEY]: ListState;
};

export const { install, action: RECEIVE_LIST } = createToolPod(STATE_KEY, "RECEIVE_LIST");
export default install;
